import { React, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import DatePicker from './DatePicker'
import { useState } from 'react';
import TextEditor from '../../shared-components/TextEditor';
import { enumUtil } from '../../utils/Enum';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import isNull from '../../utils/NullChecking';
import NotificationHandler from '../../utils/NotificationHandler';
import format from 'date-fns/format';
import { useSelector } from 'react-redux';
import DeleteConfirmatiom from './DeleteConfirmation';
import Loader from '../shared/Loader/Loader';
import DateValidator from '../../utils/DateValidator';
import FormValidator from '../../utils/FormValidator';
import { FindFirstChild } from '../../utils/FindMenuOption';
import ModalFooter from '../Setup/Shared/ModalFooter';
const Addalert = (props) => {
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer);
    const reduxcurrentDate = DropdownData?.CurrentPracticeDate;
    let IsEditAllowedAlerts = FindFirstChild('Miscellaneous', 'Alters')?.IsAdd

    let CaregiverIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    CaregiverIDR = CaregiverIDR?.data?.id
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let ClaimIDR = useSelector(state => state.Open_Claim_Tab.find((pt) => pt.active === true));
    ClaimIDR = ClaimIDR?.data?.id
    let PaymentIDR = useSelector(state => state.Open_Payment_Tab.find((pt) => pt.active === true))?.data?.id;
    let CheckType = useSelector(state => state.Open_Payment_Tab.find((pt) => pt.active === true))?.data.checkType;
    const API_URL = enumUtil.controller.General

    let Alert_Modal = {
        PatientID: "",
        ClaimID: "",
        AlertID: "",
        Title: "",
        Contains: "",
        StartDate: null,
        EndDate: null,
        // Global: '',
        Alert_in_Appointment: '',
        Alert_in_Claim: '',
        Alert_in_Patient: '',
        Alert_in_Payment: '',
        UpdatedDate: '',
        UpdatedBy: '',
        IsActive: ''
    };
    let valoModalDate = {}
    let dateValidation = {
        DateVal: '',
    }
    let Task_modeld = {
        Contains: "",
    };
    const [error, setError] = useState(dateValidation);
    const { isOpenAlertType, onClose, loadAlertData, onDeleteDiagnosis, Name } = { ...props };
    const [isLoading, setIsLoading] = useState(false);
    const [del, setDel] = useState(false)
    const [mainAlertTypeModal, setmainAlertTypeModal] = useState(Alert_Modal);
    const [mainTaskmanagementmodeld, setmainTaskmanagementmodeld] = useState(Task_modeld);
    const [TaskSaveupdatemodeld, setTaskSaveupdatemodeld] = useState({});

    const [AlertSaveUpdateModal, setAlertSaveUpdateModal] = useState({});
    const [onAlertTypeSave, setOnAlertTypeSave] = useState(false)
    const [addAlertID, setaddAlertID] = useState('')
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [activeStatus, setActiveStatus] = useState('Active');
    const isActiveValue = activeStatus === 'Active' ? '1' : '0';



    useEffect(() => {
        if (props.Contains != null) {
            setaddAlertID(props.Contains)
            setDel(true)
        } else {
            if (!onAlertTypeSave) {
                setaddAlertID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (mainAlertTypeModal.StartDate === null) {
            const currentDate = reduxcurrentDate
            setStartDate(currentDate);
            handleCalendarChange(currentDate, 'StartDate');
        }
        if (!isNull(addAlertID) && !isNull(addAlertID !== '0')) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": addAlertID,
                "TableName": enumUtil.enumAPITableName.Alert,
                // "SearchCriteria" : {"PatientID": PateintIDR}
            }).then((response) => {
                setIsLoading(false)
                setmainAlertTypeModal(response)
                setmainTaskmanagementmodeld(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
        setActiveStatus('Active');
    }, [addAlertID])
    useEffect(() => {
        if (isOpenAlertType && props.type === 'PatientID') {
            AlertSaveUpdateModal['PatientID'] = PateintIDR;
        }
        else if (isOpenAlertType && props.type === 'Claim') {
            AlertSaveUpdateModal['ClaimID'] = ClaimIDR;
        }
        else if (isOpenAlertType && props.type === 'Payment') {
            AlertSaveUpdateModal['PaymentID'] = PaymentIDR;
        }
        else if (isOpenAlertType && props.type === 'Caregiver') {
            AlertSaveUpdateModal['CaregiverID'] = CaregiverIDR;
        }
    })
    const validateDates = async () => {
        let ValidationModal = {
            DateVal: DateValidator(
                mainAlertTypeModal.StartDate,
                mainAlertTypeModal.EndDate,
                enumUtil.enumValidationType.StartEndDate,
                'Date',
            ),
        }
        await setError(ValidationModal)
        valoModalDate = ValidationModal
    };
    const handleSaveAlertType = async () => {
        if (IsEditAllowedAlerts) {
            await validateDates()
            let validation1 = FormValidator([valoModalDate], enumUtil.enumValidationType.NullCheck)
            if (validation1) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                let saveModal = {
                    TableName: enumUtil.enumAPITableName.Alert,
                    ID: addAlertID,
                    data: { ...AlertSaveUpdateModal,
                        ...TaskSaveupdatemodeld, 
                        ...(AlertSaveUpdateModal?.['PaymentID'] && { PaymentType: CheckType }), IsActive: isActiveValue },
                    value: null
                };
                setIsLoading(true);
                ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                    .then((response) => {
                        console.log("API Response:", response);
                        setIsLoading(false);
                        if (!isNull(response.id)) {
                            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);
                            setaddAlertID(response.id);
                            setOnAlertTypeSave(true);
                        }
                    }).catch((error) => {
                        console.error("API Error:", error);
                        setIsLoading(false);
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.warning);
                    });
            }

        }

        // setActiveStatus('Active');
    }

    // const handleCalendarChange = (date, type) => {
    //     var FormatedDate = date
    //     let modal = { ...mainAlertTypeModal };
    //     let saveModal = { ...AlertSaveUpdateModal }
    //     modal[type] = FormatedDate
    //     setmainAlertTypeModal(modal)
    //     for (var property in Alert_Modal) {
    //         if (type === property) {
    //             saveModal[type] = FormatedDate
    //         }
    //     }
    //     setAlertSaveUpdateModal(saveModal)
    // }

    const handleCalendarChange = (date, type) => {
        var FormatedDate = date;
        let modal = { ...mainAlertTypeModal };
        let saveModal = { ...AlertSaveUpdateModal };

        // Validation: Prevent invalid selection and show notification only
        if (type === 'StartDate' && modal.EndDate && new Date(FormatedDate) > new Date(modal.EndDate)) {
            NotificationHandler('Please Select Correct Date', enumUtil.enumtoaster.error);
            return; // Stop here, do not update date
        }
        if (type === 'EndDate' && modal.StartDate && new Date(FormatedDate) < new Date(modal.StartDate)) {
            NotificationHandler('Please Select Correct Date', enumUtil.enumtoaster.error);
            return; // Stop here, do not update date
        }

        // Only update if validation passes
        modal[type] = FormatedDate;
        setmainAlertTypeModal(modal);

        for (var property in Alert_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate;
            }
        }
        setAlertSaveUpdateModal(saveModal);
    };
    const handleAlertTypeChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainAlertTypeModal };
        let saveModal = { ...AlertSaveUpdateModal }

        if (name === 'Global') {

        }
        if (name === "Global" || name === 'Alert_in_Appointment' || name === 'Alert_in_Patient' || name === 'Alert_in_Claim' || name === 'Alert_in_Payment') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainAlertTypeModal(modal)
        for (var property in Alert_Modal) {
            if (name === property) {
                if (name === "Global" || name === 'Alert_in_Appointment' || name === 'Alert_in_Patient' || name === 'Alert_in_Claim' || name === 'Alert_in_Payment') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        if (name === 'display') {
            setActiveStatus(value); // Update active status
        }
        setAlertSaveUpdateModal(saveModal)
    }
    const handleAlertTypeChangee = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainAlertTypeModal };
        let saveModal = { ...AlertSaveUpdateModal }


        modal[name] = value
        setmainAlertTypeModal(modal)
        for (var property in Alert_Modal) {
            if (name === property) {

                saveModal[name] = value
            }
        }
        if (name === 'display') {
            setActiveStatus(value); // Update active status
        }
        setAlertSaveUpdateModal(saveModal)
    }
    const handleOnChanged = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainTaskmanagementmodeld };
        let saveModal = { ...TaskSaveupdatemodeld };
        modal[name] = value;
        setmainTaskmanagementmodeld(modal);
        for (var property in Task_modeld) {
            if (name === property) {
                saveModal[name] = value;
            }
        }
        setTaskSaveupdatemodeld(saveModal);
    };
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    const handleCloseAlert = () => {
        onClose();
        setaddAlertID(0);
        setOnAlertTypeSave(false);
        setmainAlertTypeModal(Alert_Modal);
        if (!isNull(loadAlertData)) {
            loadAlertData();
        }
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className='btn-icon-transparent' onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Alert} value={addAlertID} onClose={onDeleteDiagnosis} />
    }
    return (
        <>
            <Modal show={isOpenAlertType} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal ar_palceholder">
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    <div className='br-clr'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <div className="opened-block__head pb-2">
                                        <p className="heading fs-14 dark-clr">Alert Message</p>
                                        <button className="btn-icon-transparent" onClick={handleCloseAlert}>
                                            <i className="icon-x-cros fs-20 dark-clr"></i>
                                        </button>
                                    </div>

                                    <div className="opened-block__lite">
                                        <TextEditor
                                            value={mainTaskmanagementmodeld.Contains}
                                            setValue={(value) =>
                                                handleOnChanged({
                                                    target: { name: "Contains", value },
                                                })}
                                        />

                                        <div className="row opened-block__lite__form mt-2">
                                            <div className="col-md-4 pe-0">
                                                <DatePicker
                                                    label="Start Date"
                                                    value={mainAlertTypeModal.StartDate}
                                                    maxDate={mainAlertTypeModal.EndDate ? new Date(mainAlertTypeModal.EndDate) : undefined}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate')}
                                                />
                                            </div>
                                            <div className={error.DateVal ? 'col-md-4 pe-0 error' : 'col-md-4 pe-0'}>
                                                <DatePicker
                                                    label="End Date"
                                                    value={mainAlertTypeModal.EndDate}
                                                    minDate={mainAlertTypeModal.StartDate ? new Date(mainAlertTypeModal.StartDate) : undefined}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate')}
                                                />
                                                {error.DateVal}
                                            </div>
                                            <div className="col-md-4 ps-1 d-flex align-items-end">
                                                <div className="d-flex align-items-center justify-content-between gap-2">
                                                    <div className="form-check input-group-rad d-flex align-items-center">
                                                        <input type="radio" name="display" id="Active" value="Active"
                                                            defaultChecked={activeStatus === 'Active'} // Set default checked based on activeStatus
                                                            onChange={(e) => setActiveStatus(e.target.value)}
                                                        />
                                                        <p for="Active" className='text'>Active</p>
                                                    </div>
                                                    <div className="form-check input-group-rad d-flex align-items-center">
                                                        <input type="radio" name="display" id="InActive" value="InActive"
                                                            defaultChecked={activeStatus === 'InActive'} // Set default checked based on activeStatus
                                                            onChange={(e) => setActiveStatus(e.target.value)}
                                                            disabled={addAlertID === 0}
                                                        />
                                                        <p for="InActive" className='text'>InActive</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-7 mt-1 ps-2">
                                                <p className='text font-m ps-1-5'>Display Alert in:</p>
                                                {Name === 'Patient' && (<>
                                                    <div className='d-flex pb-2 align-items-center'>
                                                        <div className='col-md-7'>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="form-check d-flex custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Appointment"
                                                                        name='Alert_in_Appointment'
                                                                        checked={mainAlertTypeModal.Alert_in_Appointment}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text'>Appointment Section</p>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-5'>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Patient"
                                                                        name='Alert_in_Patient'
                                                                        checked={mainAlertTypeModal.Alert_in_Patient}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text text-nowrap'>Patient Section </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className='d-flex align-items-center'>
                                                        <div className='col-md-7'>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Claim"
                                                                        name='Alert_in_Claim'
                                                                        checked={mainAlertTypeModal.Alert_in_Claim}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text'> Claim Section </p>

                                                            </div>
                                                        </div>

                                                        <div className='col-md-5'>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Payment"
                                                                        name='Alert_in_Payment'
                                                                        checked={mainAlertTypeModal.Alert_in_Payment}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text text-nowrap'>Payment Section</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </>)}
                                            </div>
                                            {Name === 'Claim' && (
                                                <div className='d-flex align-items-center'>
                                                    <div className='col-md-3'>
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <div className="form-check custom_check_box">
                                                                <input type="checkbox"
                                                                    className="form-check-input p-0"
                                                                    id="Alert_in_Claim"
                                                                    name='Alert_in_Claim'
                                                                    checked={mainAlertTypeModal.Alert_in_Claim}
                                                                    onChange={(e) => handleAlertTypeChange(e)}
                                                                />
                                                            </div>
                                                            <p className='text pt-1'>Claim Section</p>
                                                        </div>

                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <div className="form-check custom_check_box">
                                                                <input type="checkbox"
                                                                    className="form-check-input p-0"
                                                                    id="Alert_in_Payment"
                                                                    name='Alert_in_Payment'
                                                                    checked={mainAlertTypeModal.Alert_in_Payment}
                                                                    onChange={(e) => handleAlertTypeChange(e)}
                                                                />
                                                            </div>
                                                            <p className='text text-nowrap'>Payment Section</p>
                                                        </div>

                                                    </div>


                                                </div>
                                            )}
                                            {Name === 'Payment' && (
                                                <div className="form-check custom_check_box">
                                                    <input type="checkbox"
                                                        className="form-check-input p-0"
                                                        id="Alert_in_Payment"
                                                        name='Alert_in_Payment'
                                                        checked={mainAlertTypeModal.Alert_in_Payment}
                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                    />
                                                    <p className='text mt-1'>Payment Section</p>
                                                </div>
                                            )}
                                            {Name !== 'Patient' && Name !== 'Claim' && Name !== 'Payment' && (

                                                <>
                                                    <div className='d-flex pb-2 align-items-center'>
                                                        <div className='col-md-7'>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="form-check d-flex custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Appointment"
                                                                        name='Alert_in_Appointment'
                                                                        checked={mainAlertTypeModal.Alert_in_Appointment}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text'>Appointment Section</p>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-5'>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Patient"
                                                                        name='Alert_in_Patient'
                                                                        checked={mainAlertTypeModal.Alert_in_Patient}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text text-nowrap'>Patient Section </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className='d-flex align-items-center'>
                                                        <div className='col-md-7'>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Claim"
                                                                        name='Alert_in_Claim'
                                                                        checked={mainAlertTypeModal.Alert_in_Claim}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text'> Claim Section </p>

                                                            </div>
                                                        </div>

                                                        <div className='col-md-5'>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <div className="form-check custom_check_box">
                                                                    <input type="checkbox"
                                                                        className="form-check-input p-0"
                                                                        id="Alert_in_Payment"
                                                                        name='Alert_in_Payment'
                                                                        checked={mainAlertTypeModal.Alert_in_Payment}
                                                                        onChange={(e) => handleAlertTypeChange(e)}
                                                                    />
                                                                </div>
                                                                <p className='text text-nowrap'>Payment Section</p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </>
                                            )}
                                            {/* <div className="col-md-7 mt-1 ps-2">
                                                <p className='text font-m ps-1-5'>Display Alert in:</p>
                                                <div className='d-flex pb-2 align-items-center gap-2'>
                                                    <div className='d-flex align-items-center gap-1'>
                                                        <div className="form-check d-flex custom_check_box">
                                                            <input type="checkbox"
                                                                className="form-check-input p-0"
                                                                id="Alert_in_Appointment"
                                                                name='Alert_in_Appointment'
                                                                checked={mainAlertTypeModal.Alert_in_Appointment}
                                                                onChange={(e) => handleAlertTypeChange(e)}
                                                            />
                                                        </div>
                                                        <p className='text'>Appointment Section</p>
                                                    </div>
                                                    <div className='d-flex align-items-center gap-1'>
                                                        <div className="form-check custom_check_box">
                                                            <input type="checkbox"
                                                                className="form-check-input p-0"
                                                                id="Alert_in_Patient"
                                                                name='Alert_in_Patient'
                                                                checked={mainAlertTypeModal.Alert_in_Patient}
                                                                onChange={(e) => handleAlertTypeChange(e)}
                                                            />
                                                        </div>
                                                        <p className='text'>Claim Section</p>
                                                    </div>
                                                </div>

                                                <div className='d-flex  align-items-center justify-content-between'>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="form-check custom_check_box">
                                                            <input type="checkbox"
                                                                className="form-check-input p-0"
                                                                id="Alert_in_Claim"
                                                                name='Alert_in_Claim'
                                                                checked={mainAlertTypeModal.Alert_in_Claim}
                                                                onChange={(e) => handleAlertTypeChange(e)}
                                                            />
                                                        </div>
                                                        <p className='text'>Payment Section</p>

                                                    </div>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="form-check custom_check_box">
                                                            <input type="checkbox"
                                                                className="form-check-input p-0"
                                                                id="Alert_in_Payment"
                                                                name='Alert_in_Payment'
                                                                checked={mainAlertTypeModal.Alert_in_Payment}
                                                                onChange={(e) => handleAlertTypeChange(e)}
                                                            />
                                                        </div>
                                                        <p className='text'>Patient Section</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                    <button className="btn btn-gray" onClick={handleCloseAlert}>Close</button>
                                    <button className="btn btn-orange" onClick={handleSaveAlertType}>Save</button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <ModalFooter isSaved={handleCloseAlert} handleSave={handleSaveAlertType} key={111} Name={'Alert'} UpdatedDate={mainAlertTypeModal.UpdatedDate} UpdatedBy={mainAlertTypeModal.UpdatedBy} ID={addAlertID} IsEditAllowed={IsEditAllowedAlerts} />
                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleCloseAlert}>Close</button>
                    <button className={IsEditAllowedAlerts ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={handleSaveAlertType}>Save</button>
                </div> */}
            </Modal>
        </>
    );
};

export default Addalert;